module.exports = __webpack_public_path__ + "c1a12b323a77f950bf223c72cd7bd3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3004_teaser_image.jpg
// module id = 614
// module chunks = 0